<!--
TODO:
* Add ribbon/stamp/seal to right top corner as status (valid (green) / invalid (red))
* Display in reel/slider? group by types?
  * Or in grid? With paginator? "Collection book" layout?
  * Either downscale (and display in "grid") OR use carousel..?
* Fix icons + colors everywhere
* Fix naming @ header (plurals etc)
* Increase logo size (longer id hashes cant fit in (5 digit is max...))
* Bg patterns ("money paper" or "hologram" effect)
  * Hologram to icon (animate rbg colors @ bg/icon?)? Papergrain to bg?
    * Switch icon bg's color rather than fill (now that theres bg pattern too?)?
* Add foil effect (from pokemon cards) to backgrounds? (or too blingy?)
  * Each has different color shade; global has rgb (classic foil?)
* Move "valid" to right side (bottom right corner as a "stamp"? - align with ID) to save Y space?
* "Info tooltip box" @ the beginning briefly explaining how licenses/resources work
* Stars/icons/ribbons/effects to (header?) to give them more "prestige"
* API changes
  * Can we add PDF/Datasets counts? If fast (for 100x+ licenses @ init (or separate request afterwards)) -> add it as small "bubbles" with icon+count only
* Add "want to license more data" section to bottom @ Licenses.vue?
* Expired licenses:
  * Gray them out
  * Add dashes to values (some/most)
* Order:
  * Global -> datasets -> pdfs -> topics -> ... ->>> EXPIRED (in same order)
-->
<template>
  <div
    :class="['license', 'license--' + type]"
    content="Click to search licensed resources"
    v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
  >
  <!--
    <div class="license__header">
      <h3>&raquo; {{ type }} license &laquo;</h3>
      <!x--
      <div>
        <h3>{{ type }} license</h3>
      </div>

      <div class="license__status license__status--xxxxvalid">{{ status }}</div>
      -->

      <!--<div>
        <router-link to="/search" class="link">View</router-link>
      </div>-x->
    </div>-->

    <div class="license__content">
      <div :class="['license__status', 'license__status--' + type]">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M12 0l1.33 1.893 1.775-1.484.796 2.173 2.099-.974.206 2.305 2.279-.398-.397 2.279 2.305.206-.975 2.099 2.173.795-1.484 1.775 1.893 1.331-1.893 1.331 1.484 1.775-2.173.795.975 2.099-2.305.206.397 2.279-2.279-.398-.206 2.305-2.099-.974-.796 2.173-1.775-1.484-1.33 1.893-1.331-1.893-1.775 1.484-.795-2.173-2.099.974-.206-2.305-2.279.398.398-2.279-2.305-.206.974-2.099-2.173-.795 1.484-1.775-1.893-1.331 1.893-1.331-1.484-1.775 2.173-.795-.974-2.099 2.305-.206-.398-2.279 2.279.398.206-2.305 2.099.974.795-2.173 1.775 1.484z"/></svg>
      </div>

      <div :class="['license__statusIcon', 'license__status--' + type]">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.334 11.96c-.713-.726-.872-1.829-.393-2.727.342-.64.366-1.401.064-2.062-.301-.66-.893-1.142-1.601-1.302-.991-.225-1.722-1.067-1.803-2.081-.059-.723-.451-1.378-1.062-1.77-.609-.393-1.367-.478-2.05-.229-.956.347-2.026.032-2.642-.776-.44-.576-1.124-.915-1.85-.915-.725 0-1.409.339-1.849.915-.613.809-1.683 1.124-2.639.777-.682-.248-1.44-.163-2.05.229-.61.392-1.003 1.047-1.061 1.77-.082 1.014-.812 1.857-1.803 2.081-.708.16-1.3.642-1.601 1.302s-.277 1.422.065 2.061c.479.897.32 2.001-.392 2.727-.509.517-.747 1.242-.644 1.96s.536 1.347 1.17 1.7c.888.495 1.352 1.51 1.144 2.505-.147.71.044 1.448.519 1.996.476.549 1.18.844 1.902.798 1.016-.063 1.953.54 2.317 1.489.259.678.82 1.195 1.517 1.399.695.204 1.447.072 2.031-.357.819-.603 1.936-.603 2.754 0 .584.43 1.336.562 2.031.357.697-.204 1.258-.722 1.518-1.399.363-.949 1.301-1.553 2.316-1.489.724.046 1.427-.249 1.902-.798.475-.548.667-1.286.519-1.996-.207-.995.256-2.01 1.145-2.505.633-.354 1.065-.982 1.169-1.7s-.135-1.443-.643-1.96zm-12.584 5.43l-4.5-4.364 1.857-1.857 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.642z"/></svg>
      </div>

      <div class="license__contentLeft">
        <div
          :class="['license__icon', 'license__icon--' + type, 'license__icon--' + getFilterIconSize(type)]"
          v-html="getFilterIcon(type)"
        />
        <div class="license__id"><span>#</span>{{ id }}</div>
      </div>

      <div class="license__contentRight">
        <div
          class="license__type"
          v-html="'&raquo; ' + getType(type) + ' &laquo;'"
        />

        <div
          class="license__name"
          v-html="getName()"
        />

        <div
          class="license__owner"
          v-html="'@' + owner"
        />

        <div class="license__info">
          <div :title="'Issued at ' + validFrom">
            <span>Iss</span>
            <span v-html="validFrom" /> <!-- Format inside, take full string @ validFrom -->
          </div>

          <div :title="'Expires at ' + validTo">
            <span>Exp</span>
            <span v-html="validTo" />
          </div>
        </div>

        <!--<div class="license__status license__status--valid">{{ status }}</div>-->
      </div>
    </div>

    <!--<svg class="green" width="100" height="50" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <linearGradient id="gradient">
        <stop class="main-stop" offset="0%" />
        <stop class="alt-stop" offset="100%" />
      </linearGradient>
      <rect width="100" height="50" fill="url(#gradient)" />
    </svg>

    <svg class="green" width="100" height="50" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <linearGradient id="gradientB">
        <stop class="alt-stop" offset="0%" />
        <stop class="main-stop" offset="50%" />
      </linearGradient>
      <rect width="100" height="50" fill="url(#gradient)" />
    </svg>-->
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    type: {
      type: String,
      default: 'invalid',
      validator (values) {
        return ['invalid', 'global', 'private', 'public', 'datasets', 'pdfs', 'news', 'topics', 'locations', 'trade_types', 'scales', 'providers', 'ai'].includes(values)
      }
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: [Boolean, String],
      default: false
    },
    owner: {
      type: String,
      default: ''
    },
    validFrom: {
      type: String,
      default: ''
    },
    validTo: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'invalid',
      validator (values) {
        return ['valid', 'invalid'].includes(values)
      }
    }
  },
  methods: {
    getName () {
      let name = this.name

      if (!name || name === false) {
        if (this.type === 'global') {
          name = 'FULL ACCESS'
        } else if (this.type === 'ai') {
          name = 'Access to AI service'
        }
      }

      return name
    },
    getType () {
      let type = this.getFilterName(this.type)

      if (!type || type === false) {
        type = this.type
      }

      return type
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.license {
  position: relative;
  width: 100%;
  background-color: $bg-2;
  border-radius: 2px;
  //border: 1px solid $bg-1;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
  transition: transform ease-out 0.1s;

  &:hover {
    transform: translateY(-6px);
    cursor: pointer;
  }

  &--global {
    fill: $white;
    background-color: rgba($yellow, 0.25);

    &:hover {
      background-color: rgba($yellow, 0.4);
    }
  }

  &--topics {
    fill: $white;
    background-color: rgba($blue, 0.45);

    &:hover {
      background-color: rgba($blue, 0.3);
    }
  }

  &--locations {
    fill: $white;
    background-color: rgba($green, 0.25);

    &:hover {
      background-color: rgba($green, 0.4);
    }
  }

  &--trade_types {
    fill: $white;
    background-color: rgba($yellow, 0.55);

    &:hover {
      background-color: rgba($yellow, 0.4);
    }
  }

  &--scales {
    fill: $white;
    background-color: rgba($orange, 0.45);

    &:hover {
      background-color: rgba($orange, 0.3);
    }
  }

  &--providers {
    fill: $white;
    background-color: rgba($pink, 0.45);

    &:hover {
      background-color: rgba($pink, 0.3);
    }
  }

  /*&__header {
    position: relative;
    top: 8px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    h3 {
      @include font('content--md', $black, 0.9);
      text-transform: uppercase;
      text-align: center;
      margin-left: 68px;
      background-color: $bg-5;
      border-radius: 4px;
      padding: 0 0.5rem;

      @media screen and (min-width: $breakpointLg) {
        @include font('header--md', $white, 0.9);
      }
    }
  }*/

  &__icon {
    background-color: $green;
    padding: 0.5rem;
    border-radius: 4px;
    //border: 1px solid $white;
    fill: rgba($white, 0.9);
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='20' viewBox='0 0 100 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.184 20c.357-.13.72-.264 1.088-.402l1.768-.661C33.64 15.347 39.647 14 50 14c10.271 0 15.362 1.222 24.629 4.928.955.383 1.869.74 2.75 1.072h6.225c-2.51-.73-5.139-1.691-8.233-2.928C65.888 13.278 60.562 12 50 12c-10.626 0-16.855 1.397-26.66 5.063l-1.767.662c-2.475.923-4.66 1.674-6.724 2.275h6.335zm0-20C13.258 2.892 8.077 4 0 4V2c5.744 0 9.951-.574 14.85-2h6.334zM77.38 0C85.239 2.966 90.502 4 100 4V2c-6.842 0-11.386-.542-16.396-2h-6.225zM0 14c8.44 0 13.718-1.21 22.272-4.402l1.768-.661C33.64 5.347 39.647 4 50 4c10.271 0 15.362 1.222 24.629 4.928C84.112 12.722 89.438 14 100 14v-2c-10.271 0-15.362-1.222-24.629-4.928C65.888 3.278 60.562 2 50 2 39.374 2 33.145 3.397 23.34 7.063l-1.767.662C13.223 10.84 8.163 12 0 12v2z' fill='%23c4c9ce' fill-opacity='0.3' fill-rule='evenodd'/%3E%3C/svg%3E");
    //fill: url('#gradient');
    animation: hologram 3s linear infinite;

    &--xs {
      min-width: 28px;
      width: 28px;
      height: 28px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 32px;
        width: 32px;
        height: 32px;
      }
    }

    &--sm {
      min-width: 32px;
      width: 32px;
      height: 32px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 36px;
        width: 36px;
        height: 36px;
      }
    }

    &--md {
      min-width: 44px;
      width: 44px;
      height: 44px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 48px;
        width: 48px;
        height: 48px;
      }
    }

    &--lg {
      min-width: 40px;
      width: 40px;
      height: 40px;

      @media screen and (min-width: $breakpointLg) {
        min-width: 44px;
        width: 44px;
        height: 44px;
      }
    }

    &--global {
      background-color: lighten(#5a4726, 15); // TODO: Temp testing, fix
    }
  }

  &__status {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    min-width: 32px;
    width: 32px;
    height: 32px;
    fill: rgba($white, 0.7);

    @media screen and (min-width: $breakpointLg) {
      min-width: 32px;
      width: 32px;
      height: 32px;
    }
  }

  &__statusIcon {
    position: absolute;
    top: calc(0.75rem + 4px);
    right: calc(0.75rem + 4px);
    min-width: 24px;
    width: 24px;
    height: 24px;
    fill: rgba($black, 0.175);

    @media screen and (min-width: $breakpointLg) {
      min-width: 18px;
      width: 18px;
      height: 18px;
    }
  }

  /*
  &__status {
    text-align: center;
    text-transform: uppercase;

    &--valid {
      color: $green;
    }

    &--invalid {
      color: $red;
    }
  }
  */

  &__id {
    width: 54px;
    text-align: center;
    font-weight: 500;
    color: rgba($black, 0.35);

    span {
      color: rgba($black, 0.2);
    }
  }

  &__type {
    text-align: center;
    font-weight: 500;
    color: rgba($black, 0.35);
    text-transform: uppercase;

    /deep/ span {
      color: rgba($black, 0.2);
    }
  }

  &__name {
    text-align: center;
    border-bottom: 1px solid rgba($black, 0.175);
    font-weight: 500;
    padding-bottom: 4px;
  }

  &__owner {
    text-align: center;
    font-weight: 500;
    color: rgba($black, 0.5);
    border-top: 1px solid rgba($white, 0.6);
    padding-top: 4px;
  }

  &__content {
    @include font('content--md', $black, 0.9);
    display: flex;
    align-items: center;
    padding: 0.5rem;
    margin: 0.5rem;
    border-radius: 4px;
    //background-color: rgba($bg-5, 0.95);
    background-color: #d4d6d8;
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='20' viewBox='0 0 100 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.184 20c.357-.13.72-.264 1.088-.402l1.768-.661C33.64 15.347 39.647 14 50 14c10.271 0 15.362 1.222 24.629 4.928.955.383 1.869.74 2.75 1.072h6.225c-2.51-.73-5.139-1.691-8.233-2.928C65.888 13.278 60.562 12 50 12c-10.626 0-16.855 1.397-26.66 5.063l-1.767.662c-2.475.923-4.66 1.674-6.724 2.275h6.335zm0-20C13.258 2.892 8.077 4 0 4V2c5.744 0 9.951-.574 14.85-2h6.334zM77.38 0C85.239 2.966 90.502 4 100 4V2c-6.842 0-11.386-.542-16.396-2h-6.225zM0 14c8.44 0 13.718-1.21 22.272-4.402l1.768-.661C33.64 5.347 39.647 4 50 4c10.271 0 15.362 1.222 24.629 4.928C84.112 12.722 89.438 14 100 14v-2c-10.271 0-15.362-1.222-24.629-4.928C65.888 3.278 60.562 2 50 2 39.374 2 33.145 3.397 23.34 7.063l-1.767.662C13.223 10.84 8.163 12 0 12v2z' fill='%23c4c9ce' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E");

    @media screen and (min-width: $breakpointLg) {
      @include font('content--lg', $black, 0.9);
      padding: 0.5rem;
      margin: 0 0.5rem 0.5rem 0.5rem;
    }

    &Left {
      // width: 68px;
      margin-right: 0.5rem;
    }

    &Right {
      flex: 1;
    }
  }

  &__info {
    display: flex;
    justify-content: center;
    font-weight: 500;

    div {
      margin: 0 0.5rem;
    }

    span:first-child {
      color: rgba($black, 0.35);
      padding-right: 4px;
      text-transform: uppercase;
    }
  }
}

// We need gradient that moves rather than chaning colors?
@keyframes hologram {
  0% { fill: rgba($white, 0.9); }
  40% { fill: rgba($white, 0.7); }
  80% { fill: rgba($bg-5, 0.7); }
  100% { fill: rgba($white, 0.9); }
}

.main-stop {
  stop-color: red;
}
.alt-stop {
  stop-color: green;
}

</style>
